export class ConfigurationDto {
    public EmailSender :string;
    public  passSender :string;
    public bookDaysGap : number;
    public BookDaysView :number;
}
